import { connect } from "react-redux";
import ChangeRequest from "./ChangeRequest";
import {
  changeRequests,
  changeRequestsLoading,
  changeRequestLoading,
  changeRequestPagination,
  getError,
} from "../../store/selectors/changeRequests.selector";
import { users } from "../../store/selectors/user.selector";
import {
  getChangeRequests,
  createChangeRequest,
  updateChangeRequest,
  deleteChangeRequest,
  createRiskRequest,
} from "../../store/actions/changeRequests.actions";
import { getUsers } from "../../store/actions/user.actions";

const mapDispatchToProps = {
  getUsersRequest: getUsers,
  getChangeRequests,
  createChangeRequest,
  updateChangeRequest,
  deleteChangeRequest,
  createRiskRequest,
};

const mapStateToProps = (state) => {
  const allRequests = changeRequests(state);
  const pageLoading = changeRequestsLoading(state);
  const loading = changeRequestLoading(state);
  // const riskLoader = riskLoading(state);
  const allUsers = users(state);
  const pagination = changeRequestPagination(state);
  const error = getError(state);
  return { error, allUsers, allRequests, pagination, loading, pageLoading };
};

export default connect(mapStateToProps, mapDispatchToProps)(ChangeRequest);
